<template>
  <no-permission :text="$t('common.noPermission')" />
</template>

<script>
import NoPermission from '@/components/noPermission.vue';
export default {
  name: "QidianNoPermission",
  components: {
    NoPermission
  }
};
</script>

<style lang="less" scoped>

</style>



// WEBPACK FOOTER //
// src/view/QiDian/NoPermission.vue